import objectFitVideos from 'object-fit-videos';

function initObjectFitVideos() {
	const videos = document.querySelectorAll('.object-fit-video');
	if (videos) {
		objectFitVideos(videos);
	}
}

document.addEventListener('DOMContentLoaded', initObjectFitVideos);
